import { render, staticRenderFns } from "./modalConfigLeads.vue?vue&type=template&id=3a8d8c86"
import script from "./modalConfigLeads.vue?vue&type=script&lang=js"
export * from "./modalConfigLeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports